import {Urls} from '../constants'
import 'styles/manualTransactionPaymentApproval.scss'
import moment from 'moment';
// import Splide from '@splidejs/splide';
//import selectize from '@selectize/selectize';

import { pagination } from "../utils/pagination.js";
import { createPop } from "../utils/createPop.js";

(function(){
	/* global $ */
	'use strict';

	let currentStateList = {
		ItemsPerPage: '50',
		page: 1,
		sortColumn: 'FirstName',
		sortType: 'desc',
		pageCount: 1,
		batchPaymentId: '',
		organisationId: '',
		payeeId: '',
		search: '',
		status: '5',
		transactionDateFrom: '',
		transactionDateTo: '',
		selectedPayments: [],
		totalSum: 0
	}

	const todaysDate = moment().format('YYYY-MM-DD');

	// async function getAuthenticate(principleId) {

	// 	fetch("/s4s/api/Authentication/CurrentUserInfo", {
    //         "headers": {
    //             "content-type": "application/json",
    //         },
    //         "body": '',
    //         "method": "POST",
    //         "mode": "cors",
    //         "credentials": "include"
    //     })
    //     .then(function(data){ 
    //         return data.json();
    //     })
    //     .then(function(data){ 
            
    //     })
	// }

	async function getTransactionsList() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api//ScheduledManualTransactionsPayment/List`);
		endpoint.searchParams.set('ItemsPerPage', currentStateList.ItemsPerPage);
		endpoint.searchParams.set('Page', currentStateList.page);
		endpoint.searchParams.set('SortColumn', currentStateList.sortColumn);
		endpoint.searchParams.set('SortType', currentStateList.sortType);
        endpoint.searchParams.set('batchPaymentId', currentStateList.batchPaymentId);
        endpoint.searchParams.set('organisationId', currentStateList.organisationId);
        endpoint.searchParams.set('payeeId', currentStateList.payeeId);
        endpoint.searchParams.set('search', currentStateList.search);
        endpoint.searchParams.set('status', currentStateList.status)
        endpoint.searchParams.set('transactionDateFrom', currentStateList.transactionDateFrom);
        endpoint.searchParams.set('transactionDateTo', currentStateList.transactionDateTo);

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}



	async function getOrganisations() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api//ScheduledManualTransactionsPayment/GetOrganisationFilterParameters`);
		endpoint.searchParams.set('Page', '1');
		endpoint.searchParams.set('SortType', 'desc');
		endpoint.searchParams.set('ItemsPerPage', '-1');

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

	async function getPayees() {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api//ScheduledManualTransactionsPayment/GetPayeeFilterParameters`);
		endpoint.searchParams.set('ItemsPerPage', '-1');
		endpoint.searchParams.set('Page', '1');
		endpoint.searchParams.set('SortType', 'desc');
		endpoint.searchParams.set('organisationId', currentStateList.organisationId);

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}

	async function getDocumentsList(thisId) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/FinanceDocument/List`);
		endpoint.searchParams.set('ItemsPerPage', '10');
		endpoint.searchParams.set('Page', '1');
		endpoint.searchParams.set('SortColumn', 'FileName');
		endpoint.searchParams.set('SortType', 'asc');
		endpoint.searchParams.set('category', '');
		endpoint.searchParams.set('principalId', thisId);
		endpoint.searchParams.set('search', '');
		endpoint.searchParams.set('state', '');

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}


	async function getManualTransactionEndpoint(transactionId) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s//api/ManualTransactions/Get/${transactionId}`);

		const response = await fetch(endpoint);
		if(response.ok){
			const data = await response.json();
			return data;

		} else {
			createPop('No payee details', `<p>No payee details were found for this transaction</p>`, 50000)
		}
	}

	async function getPayeeDetailsEndpoint(payeeId) {
		const endpoint = new URL(`${window.location.protocol}//${window.location.host}/s4s/api/Payee/Get/${payeeId}`);

		const response = await fetch(endpoint);
		const data = await response.json();
		return data;
	}


	function exportExcel(dataObj) {
		$.ajax({
			type : 'POST', 
			url : `/s4s/api//ScheduledManualTransactionsPayment/ExportToExcel?exportOption=${dataObj}&ItemsPerPage=${currentStateList.ItemsPerPage}&Page=${currentStateList.page}&SortColumn=${currentStateList.sortColumn}&SortType=${currentStateList.sortType}&batchPaymentId=${currentStateList.batchPaymentId}&organisationId=${currentStateList.organisationId}&payeeId=${currentStateList.payeeId}&search=${currentStateList.search}&status=${currentStateList.status}&selectedItems=${currentStateList.selectedPayments.toString()}&transactionDateFrom=${currentStateList.transactionDateFrom}&transactionDateTo=${currentStateList.transactionDateTo}`,
			cache: false,
			success: function(){
				createPop('Documents exported', `<p>Excel document(s) will become available in Documents as soon as it is ready.</p>`, 7000)
			},
			fail: function(){
				createPop('Unable to export', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} </p>`, 7000)
			}
		});
	}

	function initiatePayment(dataObj) {

		fetch("/s4s/api//ScheduledManualTransactionsPayment/InitiatePayment", {
            "headers": {
                "content-type": "application/json",
            },
            "body": JSON.stringify(dataObj),
            "method": "POST",
            "mode": "cors",
            "credentials": "include"
        })
        .then(function(data){ 
            
            if (data.ok) {
				return data.json();

			} else if (data.status === 400) {
                return data.json();

			// } else {
			// 	setErrors(data.statusText);
			}

        })
        .then(function(data){ 
            console.log(data)
            // Error
            if ( data.Errors.length > 0) {
				$('.js-overlay').remove();
                createPop('Unable to initiate payment', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} </p>`, 7000)
            } else {
				
				// If more than 1 results get fetched back show list in pop up otherwise redirect to the batch payments page (More than 1 will appear if multiple organisations are selected)
				// /s4s//FinanceManagementAdministration/BatchPaymentDetails/b04f591c-5e16-41a6-a4fd-affd010be397

				if (data.Data.length === 1 ) {
					window.location.href = '/s4s//FinanceManagementAdministration/BatchPaymentDetails/' + data.Data[0].Id;
				} else {

					let batchList = '';

					for( var i = 0; i < data.Data.length; i++) {
						batchList += `<li style="padding: 0.5rem 1rem; border-bottom: 1px solid #d9d9d9; text-align: left;"><a href="/s4s//FinanceManagementAdministration/BatchPaymentDetails/${data.Data[i].Id}">Batch payment: ${data.Data[i].Value}</a></li>`
					}
					createPop('Batch payments', `<p style="text-align: left;">The following batch payments have been created:</p><ul style="margin-top: 1rem; background-color: #f4f4f4;">${batchList}</ul>`, 600000)
				}
			}
        })	
	}


	function approveTransaction(dataObj) {

		$('.js-overlay').remove();
		overlay();

		fetch("/s4s/api//ManualTransactions/Approve", {
			"headers": {
				"content-type": "application/json",
			},
			"body": JSON.stringify(dataObj),
			"method": "POST",
			"mode": "cors",
			"credentials": "include"
		})
		.then(function(data){ 
			
			if (data.ok) {
				return data.json();

			} else if (data.status === 400) {
				return data.json();
			}

		})
		.then(function(data){ 
			console.log(data)
			// Error
			if ( data.Errors.length > 0) {
				$('.js-overlay').remove();
				createPop('Unable to approve transaction', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} </p>`, 7000)
			} else {
				
				$('.js-overlay').remove();
				// Create overlay
				$('body').prepend(
					`
						<div class="js-overlay" style="z-index: 10000000; text-align: center; width: 100%; height: 100%; position: fixed; background-color: rgba(0,0,0,0.6)">
							<div class="modelBox">
								<button class="js-close-model__btn close-btn" aria-label="Close"><i class="fas fa-times"></i></button>
								<section style="border-bottom: 5px solid #e0e0e0;">
									<div class="js-model-header modelHeader">
										<h1>Transaction approved</h1>
									</div>
								</section>   
								<section>
									<div class="model-body">
										<p>This transaction has been approved</p>
									</div>
								</section>    
							</div>
						</div>
					`
				)
			
				$('.js-close-model__btn').click(function(){
					getSourceList()
					populatePayeesList();
					$('.js-overlay').remove();
				});
			
				setTimeout(function() { 
					getSourceList()
					populatePayeesList();
					$('.js-overlay').remove();
				}, 5000);
			}
		})
	}

	function rejectTransaction(dataObj) {

		$('.js-overlay').remove();
		overlay();

		fetch("/s4s/api//ManualTransactions/Reject", {
			"headers": {
				"content-type": "application/json",
			},
			"body": JSON.stringify(dataObj),
			"method": "POST",
			"mode": "cors",
			"credentials": "include"
		})
		.then(function(data){ 
			
			if (data.ok) {
				return data.json();

			} else if (data.status === 400) {
				return data.json();
			}

		})
		.then(function(data){ 
			console.log(data)
			// Error
			if ( data.Errors.length > 0) {
				$('.js-overlay').remove();
				createPop('Unable to reject transaction', `<p> ${data.Errors[0].Description === null ? '' : data.Errors[0].Description} </p>`, 7000)
			} else {
				
				$('.js-overlay').remove();
				// Create overlay
				$('body').prepend(
					`
						<div class="js-overlay" style="z-index: 10000000; text-align: center; width: 100%; height: 100%; position: fixed; background-color: rgba(0,0,0,0.6)">
							<div class="modelBox">
								<button class="js-close-model__btn close-btn" aria-label="Close"><i class="fas fa-times"></i></button>
								<section style="border-bottom: 5px solid #e0e0e0;">
									<div class="js-model-header modelHeader">
										<h1>Transaction rejected</h1>
									</div>
								</section>   
								<section>
									<div class="model-body">
										<p>This transaction has been rejected</p>
									</div>
								</section>    
							</div>
						</div>
					`
				)
			
				$('.js-close-model__btn').click(function(){
					getSourceList()
					populatePayeesList();
					$('.js-overlay').remove();
				});
			
				setTimeout(function() { 
					getSourceList()
					populatePayeesList();
					$('.js-overlay').remove();
				}, 5000);
					
			}
		})
	}

	function rejectPopUp(dataObj) {

		const formBody = `
			<section>
				<label for="reject-reason_textarea">Reject reason:<span style="color: red;">*</span></label>
				<textarea id="reject-reason_textarea" style="width: 100%; height: 200px;" maxlength="140"></textarea>
			</section>
			<section>
				<button class="js-reject-btn blue-btn">Reject</button>
			</section>
		`

		createPop('Rejection reason', formBody, 800000);

		$('.js-reject-btn').off().on('click', function(){

			if ( $('#reject-reason_textarea').val() !== '' ) {
				const response = $('#reject-reason_textarea').val();
				dataObj.RejectReason = response;
				
				rejectTransaction(dataObj);
			} else {
				alert('Please provide a rejection reason.')
			}
		});

		
	}


	async function populateOrganisationList() {
		const getOrganisationsEndpoint = await getOrganisations();
		const organisations = getOrganisationsEndpoint.Data.Items;

		if ( organisations.length > 0) {

			// Only SAG users get to select an LA
			if ( $.sc.authSettings.isSag === true ) {
				$('.js-organisation-list__container').html(
					`
						<label for="organisation-list">Local authority:</label>
						<select class="js-organisation-list__list" id="organisation-list"><option data-id="" value="All">All</option></select>
					`
				);
	
				organisations.forEach(function(organisation){
					$('.js-organisation-list__list').append(
						`
							<option class="js-organisation-select" data-id="${organisation.Id}" value="${organisation.Name}">${organisation.Name}</option>
						`
					)
				});
			} else {
				$('.js-organisation-list__container').remove()
			}
		}

		// $('.js-organisation-list__list').selectize({
		// 	sortField: 'text'
		// });

		// CTA
		$('.js-organisation-list__list').off().on('change', function(){

			const organisationId = $('.js-organisation-list__list option:selected').attr('data-id');
			currentStateList.organisationId = organisationId;
			currentStateList.payeeId = '';
			currentStateList.page = 1;
			getSourceList();
			populatePayeesList();

		});

	}

	async function populatePayeesList() {
		const getPayeesEndpoint = await getPayees();
		const payees = getPayeesEndpoint.Data.Items;

		if ( payees.length > 0) {
			$('.js-payees-list__container').html(
				`
					<label for="payees-list">Payee:</label>
					<select class="js-payees-list__list" id="payees-list"><option data-id="" value="All">All</option></select>
				`
			);

			payees.forEach(function(payee){
				$('.js-payees-list__list').append(
					`
						<option class="js-payees-select" data-id="${payee.Id}" value="${payee.Name}">${payee.Name}</option>
					`
				)
			});
		}

		// CTA
		$('.js-payees-list__list').off().on('change', function(){

			const payeeId = $('.js-payees-list__list option:selected').attr('data-id');
			currentStateList.payeeId = payeeId;
			currentStateList.page = 1;
			getSourceList();
		});

	}

	async function getSourceList() {

		//resetValues();
		overlay();
		const getSourceListEndpoint = await getTransactionsList();
		const sources = getSourceListEndpoint.Data.Items;

		$('.js-overlay').remove();
		$('.js-source__list').html('');

		// Guard clause
		if ( sources.length === 0 ) {

			$('.js-source__list').append(
                `
                    <li>There are no sources available.</li>
                `
			)
			return;
		}

		sources.forEach((source)=> {

            const thisStatus = convertStatuses(source.Status);
			const currentBalance = source.CurrentPbaBalance;
			const amount = source.Amount;
			let availableBalance;
			let isSelected = false;

			let parsedCurrentBalance = parseFloat(currentBalance).toFixed(2);
			parsedCurrentBalance = '£' + parsedCurrentBalance;

			let parsedAmount = Math.abs(amount); // Turn number positive;
			// Work out available balance
			availableBalance = currentBalance - parsedAmount;

			parsedAmount = parseFloat(parsedAmount).toFixed(2);
			let parsedAmountWithPound = '£' + parsedAmount;

			availableBalance = parseFloat(availableBalance).toFixed(2);
			availableBalance = '£' + availableBalance;

			// Loop through selected items to reapply the selected class on these items
			currentStateList.selectedPayments.forEach(function (item, index) {
				if ( item === source.Id ) {
					isSelected = true;
				}
			});

			const selectBtn = `<button class="js-select-payee__btn select-transaction blue-btn${isSelected === true ? ' selected': ''}" data-id="${source.Id}" data-amount="${parsedAmount}">${isSelected === true ? 'Remove for payment': 'Select for payment'}</button>`;
			const approveBtn = `<button class="js-approve-transaction reject-transaction blue-btn" data-id="${source.Id}" data-version="${source.Version}">Approve</button>`;
			const rejectBtn = `<button class="js-reject-transaction approve-transaction blue-btn" data-id="${source.Id}" data-version="${source.Version}">Reject</button>`;

			let actionButtons = '';
			// Unpaid - show reject button
			if (source.Status === 1 ) {
				//actionButtons = selectBtn + rejectBtn;
				actionButtons = rejectBtn;

			// Rejected - show approve button
			} else if(source.Status === 4 ){
				actionButtons = approveBtn;
			
			// Pending - show aprove and reject buttons
			} else if(source.Status === 5 ){
				actionButtons = approveBtn + rejectBtn;
			}
			

			$('.js-source__list').append(
				`
                    <li class="payee-tile${isSelected === true ? ' selected': ''}" data-id="${source.Id}">
						<div class="header-container">
                        	<h2>${source.Description}</h2>
							${thisStatus}
						</div>
						<div class="full-length">
							<p><small>Individual:</small> ${source.PrincipalName}</p> 
							<p><small>Payee:</small> ${source.PayeeName} </p>
							<p><small>Due date:</small> ${moment(source.TransactionDate).format('DD/MM/YYYY')}</p>
						</div>
						<div>
						<div>${actionButtons}</div>
							${source.BatchId === null ? '' : '<p><small>Batch Id:</small> ' + source.BatchId + '</p>'}
						</div>
						<div class="balance-info">
							<p class="account-balance">Payment amount: <strong>${parsedAmountWithPound}</strong></p>
							<p>Balance: ${parsedCurrentBalance} | Available: ${availableBalance}</p>
							<button class="" js-payee-details__btn data-id="${source.Id}" data-patternid="${source.ManualTransactionRepeatingPatternId}"><i class="fas fa-info-circle"></i> Details</button>
						</div>
					</li>
				`
						// <button class="" js-payee-document__btn data-id="${source.ManualTransactionRepeatingPatternId}"><i class="fas fa-file"></i> View document</button>
			);
		});

		// Pagination
		$('.js-pagination__container').html(
			`
				<div class="js-paid-transactions-pagination-container">
					<div class="js-pagination section hide">
						<div class="pcg-pagination">
							<a class="js-pag-button pag-previous-page lhs pagination-button" href="#">Previous</a> 
							<a class="js-pag-button pag-first-page lhs pagination-button" href="#">1</a> 
							<a class="js-pag-button pag-current-page lhs pagination-button" href="#"></a>
							<a class="js-pag-button pag-last-page lhs pagination-button" href="#"></a> 
							<a class="js-pag-button pag-next-page lhs pagination-button" href="#">Next</a>
						</div>
					</div>
				</div>
			`
		)

		currentStateList.pageCount = Math.ceil(getSourceListEndpoint.Data.Paging.TotalItemsCount / getSourceListEndpoint.Data.Paging.ItemsPerPage);
		pagination(currentStateList.page, currentStateList.pageCount, '.js-pagination__container');

		// CTA
		$('.js-select-payee__btn').click(function(){

			const thisPayee = $(this).attr('data-id');
			const thisAmount = $(this).attr('data-amount');
			
			if ( $(this).hasClass('selected') ) {
				$(this).html('Select for payment');
				$(this).removeClass('selected');
				$(this).closest('.payee-tile').removeClass('selected');
				currentStateList.totalSum -= parseFloat(thisAmount);
				
				const index = currentStateList.selectedPayments.indexOf(thisPayee);
				if (index > -1) { // only splice array when item is found
					currentStateList.selectedPayments.splice(index, 1); // 2nd parameter means remove one item only
				}
				
			} else {
				$(this).html('Remove for payment');
				$(this).addClass('selected');
				$(this).closest('.payee-tile').addClass('selected');
				currentStateList.totalSum += parseFloat(thisAmount);
				currentStateList.selectedPayments.push(thisPayee);
			}

			$('.js-total-sum').text(`Selected total: £${parseFloat(currentStateList.totalSum).toFixed(2)}`)

			// $('body').on('click', '.js-select-payee__btn', ()=> {
			// 	$(this).toggleClass('selected');
			// 	if( $(this).hasClass('selected') ) {
			// 		$(this).html('Select for payment');
			// 	} else {
			// 		$(this).html('Remove for payment');
			// 	}
			// });

			console.log('currentStateList.selectedPayments is:')
			console.log(currentStateList.selectedPayments)
		});


		const payeeBtn = document.querySelectorAll('[js-payee-details__btn]');
		payeeBtn.forEach(button => {
			button.addEventListener('click', () => {
				getPayeeDetails($(button).attr('data-id'), $(button).attr('data-patternid'))
			})
		});

		const documentBtn = document.querySelectorAll('[js-payee-document__btn]');
		documentBtn.forEach(button => {
			button.addEventListener('click', () => {
				getDocumentDetails($(button).attr('data-id'))
			})
		});



		$('.js-approve-transaction').off().on('click', function(){
			const dataObj = {
				'Id': $(this).attr('data-id'),
				'Version': $(this).attr('data-version')
			}

			approveTransaction(dataObj);
		});

		$('.js-reject-transaction').off().on('click', function(){

			const dataObj = {
				'Id': $(this).attr('data-id'),
				'Version': parseInt($(this).attr('data-version'))
			}

			rejectPopUp(dataObj);
		});


		// Sorting
		$('.js-sort-ref').off().on('click', function(){
			sortTable('Description', this);
		});
		$('.js-sort-date').off().on('click', function(){
			sortTable('TransactionDate', this);
		});
		$('.js-sort-payee').off().on('click', function(){
			sortTable('PayeeName', this);
		});
		$('.js-sort-individual').off().on('click', function(){
			sortTable('PrincipalName', this);
		});
		$('.js-sort-id').off().on('click', function(){
			sortTable('BatchId', this);
		});

		$('.js-pag-button').off().on('click', function(e){

			overlay();
			e.preventDefault();

			// Next button
			if( $(this).hasClass('pag-next-page') ) {
				if(currentStateList.page < currentStateList.pageCount){
					currentStateList.page++;		
				}

			// Previous button
			} else if( $(this).hasClass('pag-previous-page') ) {
				if(currentStateList.page > 1){
					currentStateList.page--;		
				}

			// Back to first page
			} else if( $(this).hasClass('pag-first-page') ) {
				currentStateList.page = 1;

			// Last page clicked
			} else if( $(this).hasClass('pag-last-page') ) {
				currentStateList.page = currentStateList.pageCount;

			// Page plus 1
			} else if( $(this).hasClass('js-pag-plus1') ) {
				currentStateList.page++;

			// Page plus 2
			} else if( $(this).hasClass('js-pag-plus2') ) {
				currentStateList.page = currentStateList.page + 2;

			// Page plus 3
			} else if( $(this).hasClass('js-pag-plus3') ) {
				currentStateList.page = currentStateList.page + 3;

			// Page minus 1
			} else if( $(this).hasClass('js-pag-minus1') ) {
				currentStateList.page--;

			// Page minus 2
			} else if( $(this).hasClass('js-pag-minus2') ) {
				currentStateList.page = currentStateList.page - 2;

			// Page minus 3
			} else if( $(this).hasClass('js-pag-minus3') ) {
				currentStateList.page = currentStateList.page - 3;

			// Page minus 3
			} else if( $(this).hasClass('js-pag-minus3') ) {
				currentStateList.page = currentStateList.page - 3;
			}

			getSourceList();
        });

		// $('.js-select-source').off().on('click', function(){

		// 	const principleId = $(this).attr('data-id');
		// 	const sourceName = $(this).attr('data-name');
		// 	const sourceEmail = $(this).attr('data-email');
		// 	const sourceOrgName = $(this).attr('data-orgname');

		// 	currentStateList.selectedSource = principleId;

		// 	$('.js-source__list').hide();
		// 	$('.js-source-panel').hide();
		// 	$('.js-paid-transactions').show();

		// 	currentStateList.selectedSourceName = sourceName;
		// 	currentStateList.selectedSourceEmail = sourceEmail;
		// 	currentStateList.selectedSourceOrgName = sourceOrgName;

		// 	getSourceList();
		// 	//getAuthenticate(currentStateList.selectedSource);
	
		// });
		
	}

	async function getDocumentDetails(patternId) {

		const financeDocumentsEndpoint = await getDocumentsList(patternId);
		//const payeeID = financeDocumentsEndpoint.Data.PayeeId;

		if ( financeDocumentsEndpoint.Data.Items.length === 0) {

			createPop('No documents', `<p>This payee has no documents</p>`, 50000)

		} else {
			
			const documents = populateDocumentsList(financeDocumentsEndpoint);
			const details = 
			`
				${ financeDocumentsEndpoint.Data.Items.length ? 
					`${documents}` :
					``
				}
			`;

			createPop('Documents', details)
		}
	}

	// async function getPayeeDetails(transactionId) {

	// 	const manualTransactionEndpoint = await getManualTransactionEndpoint(transactionId);
	// 	const payeeID = manualTransactionEndpoint.Data.PayeeId;

	// 	if ( payeeID === '00000000-0000-0000-0000-000000000000' || payeeID === null) {

	// 		createPop('No payee details', `<p>No payee details were found for this transaction</p>`, 50000)

	// 	} else {
	// 		const payeeDetailsEndpoint = await getPayeeDetailsEndpoint(payeeID);
	// 		const accountname = payeeDetailsEndpoint.Data.AccountName
	// 		const description = payeeDetailsEndpoint.Data.Description
	// 		const accountNo = payeeDetailsEndpoint.Data.AccountNumber
	// 		const sortCode = payeeDetailsEndpoint.Data.SortCode

	// 		const details = `
	// 			<div class="account-details">
	// 				<h2><small>Payee name</small>${accountname}</h2>
	// 				<div class="account-numbers">
	// 					<p><small>Sort code</small>${sortCode}</p>
	// 					<p><small>Account number</small>${accountNo}</p>
	// 				</div>
	// 			</div>
	// 			${description !== null ? `<p class="account-description"><small>Description</small>${description}</p>` : ''}
	// 		`
	// 		createPop('Payment details', details, 50000)
	// 	}
	// }

	async function getPayeeDetails(transactionId, patternid) {

		const manualTransactionEndpoint = await getManualTransactionEndpoint(transactionId);
		const documentsEndPoint = await getDocumentsList(patternid);

		const payeeID = manualTransactionEndpoint.Data.PayeeId;

		if ( payeeID === '00000000-0000-0000-0000-000000000000' || payeeID === null) {

			createPop('No payee details', `<p>No payee details were found for this transaction</p>`, 50000)

		} else {
			const payeeDetailsEndpoint = await getPayeeDetailsEndpoint(payeeID);
			const accountname = payeeDetailsEndpoint.Data.AccountName
			const description = payeeDetailsEndpoint.Data.Description
			const accountNo = payeeDetailsEndpoint.Data.AccountNumber
			const sortCode = payeeDetailsEndpoint.Data.SortCode

			// Documents
			const documents = populateDocumentsList(documentsEndPoint);
			const message = 
			`
				${ documents.length ? 
					`<p class="tinted"><strong>Documents:</strong><br> ${documents}` :
					``
				}
			`;


			const details = `
				<div class="account-details">
					<h2><small>Payee name</small>${accountname}</h2>
					<div class="account-numbers">
						<p><small>Sort code</small>${sortCode}</p>
						<p><small>Account number</small>${accountNo}</p>
					</div>
				</div>
				${description !== null ? `<p class="account-description"><small>Description</small>${description}</p>` : ''}
				${message !== '' ? message : ``}
			`
			createPop('Payment details', details)
		}
	}







	function populateDocumentsList(documentsEndPoint) {
		const documents = documentsEndPoint.Data.Items;
		let documentlist = '';

		documents.forEach((document)=> {
			const filepath = `/s4s//Storage/FinanceDocument/${document.Id}/${document.FileName}${document.FileExt}`;
			documentlist += `<a href="${filepath}" target="_blank">${document.FileName + document.FileExt}</a>`
			//documentlist += `<img style="width: 100%;" src="${filepath}" alt="" />${document.FileName + document.FileExt}</a>`
		});
		return documentlist;
	}

	function convertStatuses(status) {
		if ( status === 1) {
			return '<div class="status-box status-unpaid">Unpaid</div>';
		} else if (status === 2) {
			return '<div class="status-box status-payment-sent">Payment sent</div>';
		} else if (status === 3) {
			return '<div class="status-box status-paid">Paid</div>';
		} else if (status === 4) {
			return '<div class="status-box status-rejected">Rejected</div>';
		} else if (status === 5) {
			return '<div class="status-box status-pending">Pending</div>';
		}
	}

	function createDateFilters(){
		$('.js-date-container').html(
			`
				<div class="dropdown-container">
					<label for="date-field-from">From:</label>
					<input id="date-field-from" type="date" max="${todaysDate}">
				</div>
				<div class="dropdown-container">
					<label for="date-field-to">To:</label>
					<input id="date-field-to" type="date" min="">
				</div>
			`
		);

		// CTA
		// Set the To field so that the min value is equal to the current from value
		$('#date-field-from').change(function(){
			const thisDate = $(this).val();
			$('#date-field-to').attr('min', thisDate);

			currentStateList.transactionDateFrom = thisDate;
			currentStateList.page = 1;
			getSourceList();
		});

		$('#date-field-to').change(function(){
			const thisDate = $(this).val();
			currentStateList.transactionDateTo = thisDate;
			currentStateList.page = 1;
			getSourceList();
		});


	}

	function sortTable(tableHeader, el){

		$('.js-sort-btn').removeClass('selected');
		$(el).addClass('selected');
		
		currentStateList.sortColumn = tableHeader;
		if ( currentStateList.sortType === 'desc' ) {
			currentStateList.sortType = 'asc';
		} else {
			currentStateList.sortType = 'desc';
		}
		getSourceList();
	}

	function resetValues() {
		// Reset currentSate items
		currentStateList.selectedPayments = [];
		currentStateList.totalSum = 0;
		$('.js-total-sum').text(`Selected total: £0.00`)
	}

	function overlay() {
		$('body').prepend(
			'<div class="js-overlay block" style="width: 100%; height: 100%; background-color: rgba(0,0,0,0.4); z-indeX: 100; position: fixed"></div>'
		);
	}

	// https://stackoverflow.com/questions/1779013/check-if-string-contains-only-digits
	// https://stackoverflow.com/questions/66542103/match-floating-point-number-with-regular-expression
	function containsOnlyNumbers(str) {
		//return /^\d+$/.test(str); // This regex is for integers
		//return /^\d+[\.,\,]?\d+$/.test(str) // Regex to support floats
		return /(?:-?(?:\d+(?:\.\d*)|.\d+)[ \t]*)+$/.test(str) // Regex to support floats
	}


	var Attributes = {
		init: function() {
			this.adjustDom();
			this.bindUIActions();

			if( $.sc.authSettings.securityGroups.indexOf(Urls.approverSecurityGroup) > -1 || $.sc.authSettings.isSag === true) {
				getSourceList('');
				populatePayeesList();
				createDateFilters();
			}  else {

				$('.statement_container').html(
					`
						<p><strong>You do not have the required permsissions to use this feature.</strong></p>
						<p>Please <a href="/contact-us/">contact us</a> if you need anymore information.</p>
					`
				);
			}
            
		},

		adjustDom: function() {
			populateOrganisationList();
		},

		bindUIActions: function() {

			$('.js-status-list__list').off().on('change', function(){

				const statusId = $('.js-status-list__list option:selected').attr('data-id');
				currentStateList.status = statusId;
				currentStateList.page = 1;
				getSourceList();
			});

			$('body').on('click', '.js-close-model__btn', function(){
				$('.js-overlay').remove();
				populatePayeesList();
			});


			$('.js-find-source__button').click(function(){
				const searchTerm = $('#find-source__input').val();
				currentStateList.search = searchTerm;
				currentStateList.page = 1;
				getSourceList();
			});

			$('#find-source__input').keyup(function(event){
				if (event.keyCode === 13) {
					const searchTerm = $('#find-source__input').val();
					currentStateList.search = searchTerm;
					getSourceList();
				}
			});

			// Export to Excel
			$('.js-export-excel__btn').click(function(){
				$('.js-export-dropdown').toggle();
			});

			$('.js-export__btn').click(function(){
				if ( $(this).hasClass('js-export-all')) {
					// dataObj.exportOption = 'exportAll'
					exportExcel('exportAll')

				} else if ($(this).hasClass('js-export-filtered')) {
					//dataObj.exportOption = 'exportFiltered'
					exportExcel('exportFiltered')

				} else if ($(this).hasClass('js-export-selected')) {
					//dataObj.exportOption = 'exportSelected'
					exportExcel('exportSelected')

				}
			});

			// Initiate payment
			$('.js-initiate-payment__btn').click(function(){
				const dataObj = currentStateList.selectedPayments;	
				initiatePayment(dataObj);
			});

			// Reload
			$('body').on('click', '.js-close-model__btn', function(){
				getSourceList()
			});

			
			


			

		}
	};

	Attributes.init();

})();